import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ResultPage.css";
import axios from "axios";

const ResultPage = () => {
  const navigate = useNavigate();

  const [leftEye, setLeftEye] = useState("");
  const [rightEye, setRightEye] = useState("");
  const [bothEyes, setBothEyes] = useState("");
  const [message, setMessage] = useState("");

  /* ================= PROTECT PAGE ================= */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const authed = localStorage.getItem("rg_auth") === "1";
    if (!authed) {
      navigate("/visual-acuity");
    }
  }, [navigate]);

  /* ================= SAVE RESULT ================= */
  const handleSubmit = async (e) => {
  e.preventDefault();
  setMessage("");

  if (!bothEyes) {
    setMessage("❌ Both Eyes result is mandatory.");
    return;
  }

  try {
    const email = localStorage.getItem("rg_email");

    console.log("Sending to backend:", {
      email,
      leftEye,
      rightEye,
      bothEyes,
    });  // ✅ DEBUG HERE

    const res = await axios.post("/save-visual-acuity", {
      email,
      leftEye,
      rightEye,
      bothEyes,
    });

    console.log("Backend response:", res.data); // ✅ DEBUG HERE

    setMessage("✅ Result saved successfully.");
    setLeftEye("");
    setRightEye("");
    setBothEyes("");

  } catch (error) {
    console.error("Save error:", error);
    setMessage("❌ Error saving result.");
  }
};

  /* ================= LOGOUT ================= */
  const handleLogout = () => {
    localStorage.clear();
    navigate("/visual-acuity");
  };

  return (
    <div className="measure-wrapper">
      <div className="measure-card">

        <h2>How to measure (at home)</h2>

        <ul className="measure-list">
          <li>Print the chart at <strong>100% / Actual Size</strong> (no “Fit to page”).</li>
          <li>Stand at the recommended distance (example: <strong>4 meters</strong>).</li>
          <li>Cover one eye (don’t press on it) and read from <strong>largest → smallest</strong>.</li>
          <li>Record the smallest line you can read cleanly. Repeat with the other eye and both eyes.</li>
        </ul>

        <div className="measure-buttons">
          <a
            href="/visual-acuity-chart.pdf"
            download
            className="download-btn"
          >
            Download Printout (PDF)
          </a>
          <button className="preview-btn">Preview</button>
        </div>

        <p className="tip">
          Tip: If the printout has a 100 mm calibration bar, verify it with a ruler before testing.
        </p>

        <hr className="result-divider" />

        {/* ================= ENTER RESULT ================= */}
        <div className="result-section">
          <h3>Enter Your Result</h3>

          <form onSubmit={handleSubmit} className="result-form">

            {/* LEFT EYE */}
            <div className="eye-group">
              <label>Left Eye (Optional)</label>
              <select
                value={leftEye}
                onChange={(e) => setLeftEye(e.target.value)}
              >
                <option value="">Select Acuity</option>
                <option value="6/12">6/12</option>
                <option value="6/9">6/9</option>
                <option value="6/6">6/6</option>
                <option value="6/5">6/5</option>
                <option value="6/4.5">6/4.5</option>
                <option value="6/4">6/4</option>
                <option value="6/3.5">6/3.5</option>
                <option value="6/3">6/3</option>
                <option value="6/2.5">6/2.5</option>
              </select>
            </div>

            {/* RIGHT EYE */}
            <div className="eye-group">
              <label>Right Eye (Optional)</label>
              <select
                value={rightEye}
                onChange={(e) => setRightEye(e.target.value)}
              >
                <option value="">Select Acuity</option>
                <option value="6/12">6/12</option>
                <option value="6/9">6/9</option>
                <option value="6/6">6/6</option>
                <option value="6/5">6/5</option>
                <option value="6/4.5">6/4.5</option>
                <option value="6/4">6/4</option>
                <option value="6/3.5">6/3.5</option>
                <option value="6/3">6/3</option>
                <option value="6/2.5">6/2.5</option>
              </select>
            </div>

            {/* BOTH EYES (MANDATORY) */}
            <div className="eye-group">
              <label>Both Eyes (Required)</label>
              <select
                value={bothEyes}
                onChange={(e) => setBothEyes(e.target.value)}
                required
              >
                <option value="">Select Acuity</option>
                <option value="6/12">6/12</option>
                <option value="6/9">6/9</option>
                <option value="6/6">6/6</option>
                <option value="6/5">6/5</option>
                <option value="6/4.5">6/4.5</option>
                <option value="6/4">6/4</option>
                <option value="6/3.5">6/3.5</option>
                <option value="6/3">6/3</option>
                <option value="6/2.5">6/2.5</option>
              </select>
            </div>

            <button type="submit" className="submit-result-btn">
              Submit Result
            </button>

          </form>

          {message && <div className="result-message">{message}</div>}

          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>

      </div>
    </div>
  );
};

export default ResultPage;